import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: "riesgo",
    loadChildren: () => import('src/app/modules/admin/modules/credito/modules/riesgo/riesgo.module').then(m => m.RiesgoModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes),],
  exports: [RouterModule]
})
export class CreditoRoutingModule { }
